import React from 'react'
import { Helmet } from 'react-helmet-async'

import { getQueryParamsFromHash, parsePermittedQueryParams } from '@domain-group/javascript-utils'

import { Box, Button, Columns } from '@domain-group/suit-theme'

import PageHeader from '@components/PageHeader'

import useTrainingCourse from '@hooks/useTrainingCourse'

import generateTabBarItems from '../../utils/generateTabBarItems'

interface PageLayoutProps {
  activeTabBarItemKey: string,
  children: React.ReactNode,
  entityPayload: ReturnType<typeof useTrainingCourse>,
}

const PageLayout = (props: PageLayoutProps) => {
  const { activeTabBarItemKey, children, entityPayload } = props

  const {
    trainingCourse,
    urls: { trainingCoursesIndexUrl },
  } = entityPayload

  // @ts-expect-error TS2741
  const { redirect }: { redirect: string } = parsePermittedQueryParams(getQueryParamsFromHash(), ['redirect'])

  return (
    <>
      <Helmet>
        <title>Training Course | Realhub</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <Button
            // @ts-expect-error TS2322
            as="a"
            buttonStyle="secondaryUtility"
            href={redirect || trainingCoursesIndexUrl}
            size="medium"
            width="auto"
          >
            Back
          </Button>
        )}
        activeTabBarItemKey={activeTabBarItemKey}
        // @ts-expect-error TS2345
        tabBarItems={generateTabBarItems(trainingCourse)}
        title="Edit Training Course"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          {children}
        </Columns>
      </Box>
    </>
  )
}

export default PageLayout
